import { render, staticRenderFns } from "./OrderPaymentPanel.vue?vue&type=template&id=2f4af2e3"
import script from "./OrderPaymentPanel.vue?vue&type=script&lang=js"
export * from "./OrderPaymentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports